import React from 'react';
import Reflux from 'reflux';
import {Button, message, Popconfirm} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {fetchList, deleteGoods} from '../../service/returnGoods';
import {getReportType, getProductLine} from '../../service/reportForm';
import {objectSerial, config} from 'Utils';
import {getGouXiaoUnitList} from "../../service/traceOrder";
import {Actions, Store} from "../order/store";
import moment from 'moment';

class ReturnGoodsList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.salesChannelCode = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['退货管理'],
            showHideBtnIndex: 0,
            key: 0,
            selectedRowKeys: [],
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            rows: [],
            total: 0,
            searchObj: {
                orderNumber: '',
                channelCode: this.salesChannelCode.split('|')[1] || '',
                status: '',
                cusName: '',
                purchaseName: '',
                qualityBusiness: '',
                returnStartDate: moment().add(-1, 'y').format('YYYY-MM-DD'),
                returnEndDate: moment().add(1, 'days').format('YYYY-MM-DD'),
                s: 10,
                p: 1,
                productLine: '',
                erpOrderNumber: ''
            },
            returnStatusOptions: [],
            productLineOptions: [],
            loading: true
        }
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    returnStartDate: value.from + ' 00:00:00',
                    returnEndDate: value.end + ' 23:59:59'
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                orderNumber: '',
                status: '',
                cusName: '',
                purchaseName: '',
                qualityBusiness: '',
                returnStartDate: '',
                returnEndDate: '',
                channelCode: this.salesChannelCode.split('|')[1] || '',
                s: 10,
                p: 1,
                productLine: '',
                erpOrderNumber: ''
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit() {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        const searchObj = this.state.searchObj;
        fetchList({...searchObj}).then(result => {
            if (result.status && result.code == 200) {
                this._isMounted && this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        });
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsOrderGoback/ExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    getReturnStatus = () => {
        getReportType({
            sKey: 'ORDER_GOBACK_STATUS'
        }).then(res => {
            if (res.code === 200) {
                const data = res.data;
                const arr = [{
                    value: '',
                    text: '全部'
                }];
                data.forEach(item => {
                    arr.push({
                        value: item.sKey,
                        text: item.name
                    });
                })
                this.setState({
                    returnStatusOptions: arr
                });
            }
        });
    };
    // getProductLineOptions = ()=> {
    //   getProductLine({
    //     sKey: 'ORDER_GOBACK_STATUS'
    //   }).then(res=> {
    //     if (res.code === 200) {
    //       const data = res.data;
    //       const arr = [{
    //         value: '',
    //         text: '全部'
    //       }];
    //       data.forEach(item=> {
    //         arr.push({
    //           value: item.sKey,
    //           text: item.name
    //         });
    //       })
    //       this.setState({
    //         productLineOptions: arr
    //       });
    //     }
    //   });
    // };
    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'returnGoods' || path[0] === 'returnGoods') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        this._isMounted = true;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...data.storeData,
                }
            });
        }
    }

    componentDidMount() {
        this.initData();
        this.getReturnStatus();
        // this.getProductLineOptions();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    editRecord(record) {
        if (record.returnType === '质量') {
            this.goView('returnGoods/quality/' + record.id);
        } else {
            this.goView('returnGoods/business/' + record.id);
        }
    }

    deleteRecord(record) {
        deleteGoods({id: record.id}).then(res => {
            if (res.code === 200) {
                openNotice('success', '删除成功');
                this.initData();
            }
        });
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            selectedRowKeys,
            showHideBtnIndex,
            returnStatusOptions,
            productLineOptions,
            loading,
            button_limits_end,
            gouxiaoUnitList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'date',//startCreatedDate, endCreatedDate
                    label: '退货日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.returnStartDate || '',
                        end: searchObj.returnEndDate || ''
                    }
                }, {
                    name: 'orderNumber',
                    label: '退货编号',
                    text: '输入DMC退货编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'erpOrderNumber',
                    label: '退单编号',
                    text: '输入ERP退单编号',
                    type: 'default',
                    defaultValue: searchObj.erpOrderNumber
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: returnStatusOptions,
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.status || ''
                },
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'purchaseName',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.purchaseName,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'qualityBusiness',
                    label: '退货类型',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: 'Q', text: '质量退货'},
                        {value: 'B', text: '商务退货'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.qualityBusiness || ''
                },
                {
                    name: 'productLine',
                    label: '产品线',
                    text: '选择产品线',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.productLine || ''
                },
                {
                    name: 'itemNumber',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNumber
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '退货编号',
                    dataIndex: 'orderNumber',
                    render: (text, record, index) => {
                        return <a href={`#/returnGoods/${record.id}&${record.status}`}>{text}</a>
                    }
                },
                /*        {
                          title: 'ERP要货单号',
                          dataIndex: 'erpHeadId',
                          render: (text, record, index) => {
                            return <a href={`#/returnGoods/${record.id}`}>{text}</a>
                          }
                        }, */{
                    title: '状态',
                    dataIndex: 'statuStr'
                },
                {
                    title: '下一步',
                    dataIndex: 'nextStatus'
                },
                {
                    title: '退货类型',
                    dataIndex: 'returnType'
                },

                {
                    title: '产品线',
                    dataIndex: 'productLineName'
                },
                {
                    title: '退货日期',
                    dataIndex: 'returnDate'
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName'
                },
                {
                    title: '退货相关类型',
                    dataIndex: 'returnTypeName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '退货数量',
                    dataIndex: 'gobackCount'
                },
                {
                    title: '退货金额',
                    dataIndex: 'curArturnAmount'
                },
                {
                    title: '税率',
                    dataIndex: 'taxCode'
                },
                {
                    title: '退货地点',
                    dataIndex: 'gobackAddress'
                },
                {
                    title: '电话',
                    dataIndex: 'phone'
                }, {
                    title: '操作',
                    render: (text, record, index) => (
                        <div>
                            {(record.statuStr === '保存' || record.statuStr == '驳回' || record.statuStr == '已保存') ?
                                <div className="event">
                                    <Button style={{display: 'inline-block', marginRight: '10px'}} size={'small'}
                                            type="ghost"
                                            onClick={self.editRecord.bind(self, record)}>编辑</Button>
                                    <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                        this.deleteRecord(record)
                                    }}>
                                        <Button size={'small'} type="danger">删除</Button>
                                    </Popconfirm>
                                </div> :
                                <span className="btn">暂无操作</span>}
                        </div>
                    )
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <span>{total}个退货<font size={1} style={{color: 'red'}}>（默认显示一年内退货)</font></span>
                    {button_limits_end.returnGoodsQuantity &&
                    <Button style={{position: 'absolute', bottom: 8, right: 205}}
                            onClick={this.goView.bind(this, 'returnGoods/quality')}>创建质量退货</Button>}
                    {button_limits_end.returnGoodsBusiness &&
                    <Button style={{position: 'absolute', bottom: 8, right: 85}}
                            onClick={this.goView.bind(this, 'returnGoods/business')}>创建商务退货</Button>}
                    {button_limits_end.returnGoodsExport &&
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>}
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(ReturnGoodsList);



// WEBPACK FOOTER //
// ./src/routes/returnGoods/list.js